import React, { useEffect } from "react";
import cx from "classnames";
import { useNavigate } from "react-router-dom";

import styles from "./forgotPassword.module.scss";
import { useDispatch, useSelector } from "react-redux";
import Button from "src/components/button";
import _ from "lodash";
import { forgotPassword, invalidateForgotPassword } from "src/redux/actions/users";

function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [username, setUsername] = React.useState("");
  const [error, setError] = React.useState("");
  const [successView, setSuccessView] = React.useState(false);

  const loading = useSelector((state) =>
    _.get(state, "users.forgotPassword.loading"),
  );
  const success = useSelector((state) =>
    _.get(state, "users.forgotPassword.success"),
  );

  useEffect(() => {
    setSuccessView(false);
  }, []);

  useEffect(() => {
    let timeoutId;

    if (success && !loading) {
      setSuccessView(true);
      timeoutId = setTimeout(() => {
        navigate("/public/login");
      }, 5000);
    }
  
    // Cleanup function to clear the timeout on unmount
    return () => {
      clearTimeout(timeoutId);
    };
  }, [success]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (successView) {
      dispatch(invalidateForgotPassword());
      setSuccessView(false);
      navigate("/public/login");
    } else {
      const userNameError = validateUserName();
      if (!userNameError) {
        dispatch(forgotPassword({ email: username }));
      }
    }
  };

  const validateUserName = () => {
    if (!username || username.trim() == "") {
      setError("Enter a valid email id");
      return true;
    }

    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!regex.test(username)) {
      setError("Enter a valid email id");
      return true;
    }

    return false;
  };

  const renderButtonTitle = () => {
    if (successView) {
      return "Sign In";
    }
    return loading ? "Continuing" : "Continue";
  };

  const handleUserNameChange = (email) => {
    setError("");
    setUsername(email);
  };

  return (
    <div className={styles.passwordContainer}>
      <img
        src="/images/logo-text.png"
        alt="Paperflite Logo"
        className={styles.logo}
      />
      <h1 className={styles.title}>Forgot Password?</h1>
      {!successView && (
        <p className={styles.subText}>
          Please enter your email address to get instructions to reset your
          password.
        </p>
      )}
      {successView && (
        <p className={styles.subText}>
          The link to change your password has been sent to your email.
        </p>
      )}
      <form className={styles.loginForm} onSubmit={handleSubmit}>
        {!successView && (
          <input
            className={styles.input}
            type="text"
            placeholder="Enter work email"
            value={username}
            onChange={(e) => handleUserNameChange(e.target.value)}
          />
        )}
        {error && (
          <p className={styles.error}>
            <i className="paperflite-danger"></i>
            <label>{error}</label>
          </p>
        )}
        <span onClick={handleSubmit}>
          <Button
            className={styles.button}
            variant="primary"
            icon={
              successView ? "paperflite-left-arrow" : "paperflite-right-arrow"
            }
            disabled={loading}
          >
            {renderButtonTitle()}
          </Button>
        </span>
      </form>
    </div>
  );
}

export default ForgotPassword;
